import type {
  CarrierByIdForViewInterface,
  ProcessedBasicCostInterface,
  ProcessedMoreInfoInterface,
} from '@/types/carrier-types';
import { viewCarrierStructure } from '@/constants/carriers-constants';
import type { RecursivePartial } from '@/types/component';

//-- get keys of each section
// basic cost
// section 1
const bc_s1_p1_values = Object.values(
  viewCarrierStructure.basicCost.section1.part1,
);
const bc_s1_p2_values = Object.values(
  viewCarrierStructure.basicCost.section1.part2,
);
const bc_s1_p3_values = Object.values(
  viewCarrierStructure.basicCost.section1.part3,
);
//section 2
const bc_s2_bc_values = Object.values(
  viewCarrierStructure.basicCost.section2.basicCost,
);
const bc_s2_sc_values = Object.values(
  viewCarrierStructure.basicCost.section2.saleCost,
);
const bc_s2_cc_values = Object.values(
  viewCarrierStructure.basicCost.section2.creditCost,
);
// more info
const bodyDimensions = Object.values(
  viewCarrierStructure.moreInfo.bodyDimensions,
);
//--

export const pBasicCostIS: ProcessedBasicCostInterface = {
  s1: { p1: [], p2: [], p3: [] },
  s2: { bc: [], sc: [], ad: [], cc: [] },
};
export const pMoreInfoIS: ProcessedMoreInfoInterface = {
  goods: [],
  bodyDimensions: [],
  notes: null,
  comments: null,
};
export function processBasicAndCost(
  data: Partial<CarrierByIdForViewInterface>,
) {
  const processedData = structuredClone(pBasicCostIS);
  bc_s1_p1_values.forEach((key) => {
    // section 1 part 1
    if (data[key]) {
      processedData.s1.p1.push({ label: key, value: data[key] });
    }
  });
  bc_s1_p2_values.forEach((key) => {
    // section 1 part 2
    if (data[key] === false) {
      processedData.s1.p2.push({ label: key, value: data[key] });
    }
    if (data[key] && String(data[key]).toLowerCase() !== 'null') {
      processedData.s1.p2.push({ label: key, value: data[key] });
    }
  });
  bc_s1_p3_values.forEach((key) => {
    // section 1 part 3
    if (
      key === 'bidder' ||
      key === 'location' ||
      key === 'sales_person' ||
      key === 'dealer' ||
      key === 'seller' ||
      key === 'purchased_dt'
    ) {
      if (data[key]) {
        processedData.s1.p3.push({ label: key, value: data[key] });
      }
    } else {
      if (data?.auction_info?.[key]) {
        processedData.s1.p3.push({ label: key, value: data.auction_info[key] });
      }
    }
  });

  const cost_details = data.cost_details;

  bc_s2_bc_values.forEach((key) => {
    // section 2 basic cost
    if (cost_details?.[key]) {
      processedData.s2.bc.push({
        label: key,
        value: cost_details[key],
        type: 'currency',
      });
    }
  });
  bc_s2_sc_values.forEach((key) => {
    // section 2 sale cost
    if (cost_details?.[key]) {
      processedData.s2.sc.push({
        label: key,
        value: cost_details[key],
        type: 'currency',
      });
    }
  });

  // section 2 additional cost
  if (data?.cost_details?.sales_commission) {
    processedData.s2.bc.push({
      label: 'salesCommission',
      value: data.cost_details.sales_commission,
      type: 'currency',
    });
  }
  if (Array.isArray(cost_details?.additional_cost)) {
    cost_details.additional_cost.forEach((item) => {
      const key = Object.keys(item);
      key.forEach((key) => {
        if (Number(item[key])) {
          processedData.s2.ad.push({
            label: key,
            value: item[key],
            type: 'currency',
          });
        }
      });
    });
  }

  bc_s2_cc_values.forEach((key) => {
    // section 2 credit cost
    if (cost_details?.[key]) {
      processedData.s2.cc.push({
        label: key,
        value: cost_details[key],
        type: 'currency',
      });
    }
  });

  return processedData;
}

export function processMoreInfo(
  data: RecursivePartial<CarrierByIdForViewInterface>,
) {
  const processedData = structuredClone(pMoreInfoIS);

  bodyDimensions.forEach((key) => {
    if (data.more_info?.body_dimensions?.[key]) {
      processedData.bodyDimensions.push({
        label: key,
        value: data.more_info.body_dimensions[key],
      });
    }
  });

  return processedData;
}
